import {defineMessages} from 'react-intl'
import {
  PROPERTY_TYPE_HOTEL_FACET_IDS,
  PROPERTY_TYPE_VACATION_RENTALS_FACET_IDS
} from 'utils/facilities'

import {FacetGroupItem} from './FacetFilter'

export const RECENTLY_USED_FILTERS_LIMIT = 10

export const PROPERTY_TYPES_DESKTOP_LIMIT = 8
export const PROPERTY_TYPES_MOBILE_LIMIT = 3

export const PROPERTY_GROUPS: FacetGroupItem[] = [
  {
    type: 'hotels',
    facetIds: PROPERTY_TYPE_HOTEL_FACET_IDS,
    header: {
      ...defineMessages({
        title: {
          id: 'propertyType.hotelsTitle',
          defaultMessage: 'Hotels'
        },
        description: {
          id: 'propertyType.hotelsSubtitle',
          defaultMessage: 'Includes hotels, hostels, resorts and more'
        }
      }),
      groupIcon: 'Building'
    }
  },
  {
    type: 'vacationRentals',
    facetIds: PROPERTY_TYPE_VACATION_RENTALS_FACET_IDS,
    header: {
      ...defineMessages({
        title: {
          id: 'propertyType.vacationRentalsTitle',
          defaultMessage: 'Vacation rentals'
        },
        description: {
          id: 'propertyType.vacationRentalsSubtitle',
          defaultMessage:
            'Includes apartments, holiday homes, cottages and more'
        }
      }),
      groupIcon: 'House'
    }
  }
]
